module.exports = __webpack_public_path__ + "img/logo-p.c7abff69.png";